import { render } from "./FilterUpdates.vue?vue&type=template&id=2a4aef3d&scoped=true"
import script from "./FilterUpdates.vue?vue&type=script&lang=js"
export * from "./FilterUpdates.vue?vue&type=script&lang=js"

import "./FilterUpdates.vue?vue&type=style&index=0&id=2a4aef3d&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4aef3d"]])

export default __exports__